module.exports = __webpack_public_path__ + "img/educate.09c25e3b.svg";